import React from 'react'
import { Link } from 'gatsby'
import { useGetContactInfo } from '@@hooks'
import InstagramIcon from '@@icons/instagram.svg'
import EmailIcon from '@@icons/email.svg'

import StandardContainer from '../StandardContainer'

import styles from './StandardFooter.module.scss'

const renderContactInfo = () => {
  const contactInfo = useGetContactInfo()

  const contactIcons = {
    email: EmailIcon,
    instagram: InstagramIcon,
  }

  return contactInfo.map((contact) => {
    const SocialIcon = contactIcons[contact.label]
    let linkProps

    switch (contact.label) {
      case 'email':
        linkProps = {
          href: `mailto:${contact.value}`,
          target: '_top',
        }
        break
      default:
        linkProps = {
          href: contact.value,
          target: '_blank',
          rel: 'noopenner noreferrer',
        }
    }

    return (
      <li key={contact.id} className={styles.contactDetail}>
        <a {...linkProps} className={styles.contactLink}>
          <SocialIcon className={styles.icon} />
        </a>
      </li>
    )
  })
}

export const StandardFooter = () => (
  <footer className={styles.footer}>
    <StandardContainer className={styles.container}>
      <ul className={styles.contactDetails}>
        {renderContactInfo()}
      </ul>
      <div className={styles.legal}>
        <small>
          <Link to="/attributions">Attributions</Link>
        </small>
        <small>
          &copy; {new Date().getFullYear()}
        </small>
      </div>
    </StandardContainer>
  </footer>
)
